/**
 * DISCOUNT CODE FIELD — docs/52 §1 S4, 2026-08-11.
 *
 * The whole job is to turn a typed code into a navigation to
 * `/discount/<CODE>?redirect=<path>`, which is the only supported way a theme
 * can apply a discount. See snippets/cart-discount.liquid for why it is a
 * navigation and not a fetch.
 *
 * DELEGATED, because the cart page and the drawer both render this field and
 * `cart.js` REPLACES the drawer's contents wholesale through the Section
 * Rendering API on every quantity change — a listener bound to the element
 * would be discarded with it. docs/54 §1.-25 records that same replacement
 * being the reason the drawer's trust strip is rendered outside
 * `cart-drawer-items`. One document-level listener survives all of it.
 *
 * IIFE-wrapped: docs/54 §5.6 — any script a section can emit twice must be,
 * or the second copy throws at parse time on the re-declared const and the
 * guard below never runs.
 */
(function () {
  if (window.__dramourCartDiscountBound) return;
  window.__dramourCartDiscountBound = true;

  /* ONE CLASS ON <html>, NOT A MARKER PER FORM.

     The CSS reveals the field on `.js-cart-discount`. Without script the code
     cannot be applied at all — it belongs in the URL PATH, so there is no
     meaningful no-JS submit target — and a control that looks live and is not
     is the defect docs/54 §1.-22 found in two homepage CTAs.

     The first version set `data-ready` on each form and re-ran it from a
     body-wide MutationObserver, because `cart.js` replaces the drawer's
     markup wholesale on every quantity change. That would have fired on every
     DOM mutation in the document for the life of the page, to set an
     attribute — real TBT against a budget docs/54 §1.-24 measures. A class on
     the root element is set once and is still there when the drawer's
     contents are swapped, because the root is never what gets swapped. */
  document.documentElement.classList.add('js-cart-discount');

  const apply = (root) => {
    const field = root.querySelector('input[name="discount"]');
    const code = (field ? field.value : '').trim();
    if (!code) {
      field?.focus();
      return;
    }

    /* Shopify matches codes case-insensitively, but the code goes in a URL
       path segment, so it still needs encoding — real codes contain spaces
       and punctuation more often than anyone expects. */
    const redirect = root.getAttribute('data-redirect') || '/cart';
    window.location.href = `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(redirect)}`;
  };

  /* CLICK AND ENTER, because this is no longer a <form> and nothing submits.
     It was one until 2026-08-11, and on the cart page that <form> was nested
     inside Dawn's `<form action="/cart">` — invalid HTML, so the parser
     dropped it and the Apply button became a submit for the CART form. See
     the note in snippets/cart-discount.liquid. */
  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-cart-discount-apply]');
    if (!btn) return;
    const root = btn.closest('[data-cart-discount]');
    if (root) apply(root);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter') return;
    const field = event.target.closest('[data-cart-discount] input[name="discount"]');
    if (!field) return;
    /* Without this the Enter would bubble to whatever form encloses the cart
       and submit THAT — the same defect by a different route. */
    event.preventDefault();
    apply(field.closest('[data-cart-discount]'));
  });
})();
